import React from 'react';
import { SEO } from './components/SEO';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Mission } from './components/Mission';
import { Services } from './components/Services';
import { WhyChooseUs } from './components/WhyChooseUs';
import { CompanySection } from './components/CompanySection';
import { Stats } from './components/Stats';
import { Gallery } from './components/Gallery';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { CookieBanner } from './components/CookieBanner';
export function App() {
  return <div className="min-h-screen w-full bg-white font-sans text-ink antialiased" data-id="element-0">
      <SEO data-id="element-1" />
      <Header data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <About data-id="element-5" />
        <Mission data-id="element-6" />
        <Services data-id="element-7" />
        <WhyChooseUs data-id="element-8" />
        <CompanySection data-id="element-9" />
        <Stats data-id="element-10" />
        <Gallery data-id="element-11" />
        <Testimonials data-id="element-12" />
        <FAQ data-id="element-13" />
        <Contact data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
      <CookieBanner data-id="element-16" />
    </div>;
}